
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqiFecgkuaInetTWWHJU0SQE0JQULCpwV7UvimN1pRiTcMeta } from "/codebuild/output/src2789643278/src/src/pages/faq.vue?macro=true";
import { default as menu4UrgUIe73GdKEqFBj1MpQrWOU0uTGamP425SZdGsOIkMeta } from "/codebuild/output/src2789643278/src/src/pages/menu.vue?macro=true";
import { default as indexhQTgSTZRzVbMrMXGm1wiodeFu4nZwwyKfhNDSRVVFSkMeta } from "/codebuild/output/src2789643278/src/src/pages/index.vue?macro=true";
import { default as contactCRjSxcHomrysMKUFz657G5GDZjzIFS_452w45_kQPgfykMeta } from "/codebuild/output/src2789643278/src/src/pages/contact.vue?macro=true";
import { default as tutorialI3a_458KI0GqE4JqBNxQ4U9v_gG4v4U8IxCoIip_9_Rc0Meta } from "/codebuild/output/src2789643278/src/src/pages/tutorial.vue?macro=true";
import { default as agreementkRwj_LzrcmA5Azulwl_FeCSwhMoRv7btCOkeMIZ1iKcMeta } from "/codebuild/output/src2789643278/src/src/pages/agreement.vue?macro=true";
import { default as about_45passY9YvssgQ3BWOiVmP_9VPLcnIjMR_45Zcx6grEJxIjazWMMeta } from "/codebuild/output/src2789643278/src/src/pages/about-pass.vue?macro=true";
import { default as indexceKGP_45KX0HM38Fp0w3QJ0dm22AkrQcsGCbryRuzeHqIMeta } from "/codebuild/output/src2789643278/src/src/pages/card/index.vue?macro=true";
import { default as _91id_936hjIBqW568a8P0qYeIU_4515FSnthLCr00bngWSgDNr_458Meta } from "/codebuild/output/src2789643278/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceNhlAos2eCnDJc_A7nLTd_s6znKk4dwt8D3zCr80k64sMeta } from "/codebuild/output/src2789643278/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93h_45RPNIdluGbvMNuhfVjxoBKgPxtWqSb_i65agZJ4qr8Meta } from "/codebuild/output/src2789643278/src/src/pages/notice/[id].vue?macro=true";
import { default as indexdCQVJ3eZDOBttHYmITFcGegOKFvXy0Q6s0Hr34v4KZgMeta } from "/codebuild/output/src2789643278/src/src/pages/coupon/index.vue?macro=true";
import { default as indexARNO8wd116T9pg_99cgKcDjNNNBPwl3sFDraQfJ7n8EMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/index.vue?macro=true";
import { default as indexezWxujwUXY_ez_35cZUt3QNnoCToFEtctjyJDkuAnvwMeta } from "/codebuild/output/src2789643278/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93ziYZxX5XT7_1LAuP4_45mUwc1KylEiWQ43ruei_450zR7sUMeta } from "/codebuild/output/src2789643278/src/src/pages/parking/[id].vue?macro=true";
import { default as indexY6W_45CjrZRH29Gkl_knQg_60eCTd1aKlJR0U_SQS3DUgMeta } from "/codebuild/output/src2789643278/src/src/pages/history/index.vue?macro=true";
import { default as indexuIc_450SD6f27Ls96xJSXuEae7lWLBv5j_b_Rq44861_45EMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/index.vue?macro=true";
import { default as indexhyoIhcgTdbqSKcp4b5RTNVP4DTS_8kXVy5vrEosnOIcMeta } from "/codebuild/output/src2789643278/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexW1wkTDIMQDCaQYWu9V3h4ZRuQJDIvP5kHdFhRo1GXQQMeta } from "/codebuild/output/src2789643278/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavihGMprVhWfxnwrWFizyJwvBhLNkq3mxF6rSyYj2ZpRfsMeta } from "/codebuild/output/src2789643278/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editWYRIsuwSOM6_45IqypnGiMxg_8dYUqnSiDiu7mMMYl1GkMeta } from "/codebuild/output/src2789643278/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement8HjH0cvvHQgOC1b_45N3fITIls_Lj_45_6EFLamMBgPxXssMeta } from "/codebuild/output/src2789643278/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexf36YrHJZH4s7O0u27NQwa2PGBcSWHJOpBE6sRBWEjZ0Meta } from "/codebuild/output/src2789643278/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dKAsxaJtLYxXYGYDSVMO5iDa5nN9Zg8eehWbNzDrNrbcMeta } from "/codebuild/output/src2789643278/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmI_45VF1lnBMjILXZ7Lsw0X_45vnvlDc86cvi8HaoCCDxZJEMeta } from "/codebuild/output/src2789643278/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index59CaNQmQI2baCC1J4vI1TGbxMYpinL3hxxEv_P1vlg0Meta } from "/codebuild/output/src2789643278/src/src/pages/card/create/index.vue?macro=true";
import { default as indexFOuu1S8BPrOuHAYxoU6U5SX6fn83DUL4mpv1FSTYsbMMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm2UXYH7VpR4ImEusLwU3DSKsq9OGvoUpDEvxbVjXCM5gMeta } from "/codebuild/output/src2789643278/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmeKDNzv1V_IyB4qi0QzxnBYEK2qVzScsKgpKoU2ZQ1mUMeta } from "/codebuild/output/src2789643278/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete1RroXVrLXcJKDXj_0yivpwqzU3Bij388cxjRE9RDoloMeta } from "/codebuild/output/src2789643278/src/src/pages/membership/complete.vue?macro=true";
import { default as registerzi9GOQWoaNIoK1fv_qTXKLTShyyt9k6gXi7MP18Xt0MMeta } from "/codebuild/output/src2789643278/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93UlNFzV9jcHQRR4pmuwPULPhgBgHaz_45X1VjQ4JIrFLYAMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmf6T8JHGxLgSvm5_45uqt4Fta8WTTsH70pmunV2hHJlTj0Meta } from "/codebuild/output/src2789643278/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93Vkvh4jp07pe6yHohXx8e4eke4NIzMKzwLID7__456Oh7UMeta } from "/codebuild/output/src2789643278/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexfSoT2IajgOUqwlAsD3dp58AnK_45X8QqRelsItqznZnGUMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code7Bv7MetmFgGRBxn11UB4p3tam7p4GfthBcDU7GfzBX0Meta } from "/codebuild/output/src2789643278/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codehPOUwPIhEogHj6_45Q6cafp_HDpcc_x_2KFdoXRTNd6MEMeta } from "/codebuild/output/src2789643278/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completebTGmSzQNfjviUsYws9f92Nc9timfjMSsLTzgr6YxQbsMeta } from "/codebuild/output/src2789643278/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registeruayssARFl6Mkd_45ebARHmddpnkjnIwAhp9Yg_2jRFKgYMeta } from "/codebuild/output/src2789643278/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeAsxgM9GQi75Iw0PYsLY2_45wn6MWEOPELcDUKhefyu5S8Meta } from "/codebuild/output/src2789643278/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexorqVlThuAgK7jrEykYXoqLsmW_04ek_45BG6Fo87OG8E8Meta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmmcCQdSJAe_45lKUPMm220t4t95alcQR4kVk_45ublRlQhGsMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completez0RDEO6A8fSprmYlcfe67M3VNoS3Jt3DfoSZW0X21GIMeta } from "/codebuild/output/src2789643278/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexCySB7Hm2GZqvivSpI0WvxP7lbXT9AgbpNdwcpQ7amwAMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93u_45y0xsiH3dM_45CsMglmx6Gjh1pceAzZww2CqWyY9ID8QMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completetrU5ir6TUorYApa47HqwHQhdJD1Jtg2bGlzLWOdJDZYMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias8T14iFzWxdiNhS8UOxyhegEIQSFKyiojZfnp77n_45Fv8Meta } from "/codebuild/output/src2789643278/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleMuvlzRGukcCr_45sOE8IkcCDUb6HazXZOQzbOIzk6QFecMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email5HKgph4Zq3k_45hdxZzU2NBh_45g6zy0XHj8eXXyxkNXDQQMeta } from "/codebuild/output/src2789643278/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmhGa_45ebCaN5IW3ooLVTiNxcvUocQnaoNxFebmvjA_45_45GAMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentXzxfpZyLKybOYvXexUeQoUbk6G3eVrzSqBv3fwkE7AsMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmODwDnRGpIEjjOOHClkTi_45vCAF_T5TOFmnqiOdIS8d2QMeta } from "/codebuild/output/src2789643278/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateLFtBrlGdmINvmobPy3rqEPGT_45JUaFfTQDSgNX5CsFWYMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeafVJ7fdM34dV2PvuWtTcxPxKvWYHu1J5yaieDPN1ilAMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeSfEKBA5l_45Z7XWYF9yMLbtIPOCaKyBGk6yDP_jyUUL68Meta } from "/codebuild/output/src2789643278/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordwf2PwgtYOFZE_hqGEhwV_452WYJ1lq8iGGGhpuLPnAIQIMeta } from "/codebuild/output/src2789643278/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias0wl9PQeUmQMmo__3NY7JEK69cVO_45u_45XlwEdK8o7AzEcMeta } from "/codebuild/output/src2789643278/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerV9XEYnAIsGc6FsWkaoaYeKvEzVfHr0jgTq_4bZ_3i4MMeta } from "/codebuild/output/src2789643278/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeSaDYftndsEgsRWvWnDBkj_2WL0MJ1QQYNaiXi6hi2mYMeta } from "/codebuild/output/src2789643278/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexz0oAsjWku8bay8aLcLyxDHYyhMt5tmgp2NDOmdlf6zEMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index4nCmJERM99dnPgwc94BZpMQHCYYHDKYtENivUycWLicMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexUBdcKEB2KUZjZofAAkxd7_fASeasSub7T8_45UYWfNleIMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexULLj0f3mSRszOki71TcQboENwkkxulW8k8Dg3WpUV9EMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatedb9GFTe27Qa9o4FFULfurSh_QmJOOiAxG7NmVA_45baogMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completePOTRVchihExVDUi9hxpYG_EILuF2aZ_z0R3iDoX3YnwMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmTbWqFVeqAy0F6Qoq_457Y3uAeAY6U74szEi4QBWsTKlDEMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexW426kEWt8GIs2UCFKZ6aD_C6_45rZ4Aljp_9fRMVG02sQMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completehnvORCp8AUl6YCGsxjAAIsvxY7lAcEtItM37KndnOwEMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatePc8RARZE6J86RSfE03lDzdI7ExuyipQP3d_O4u5GyWgMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexur2fRy59RmlnsVhd9PVlCTP3k52fWlUuqiv86ElgnDAMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index2yi8VLKgiKenYuAtJbsZUQi6xzwGEZxstuHlhefBN2sMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete553LcEKoAQ7sKoHwLGmvgm4MJ6anD98hPBt2kO0xRYcMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexykB_45JGKh2OVfbXeDr5mkzCdo_45MIMZVKiYk0xOE5TNYUMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codewBT_457CyhuutFhFUMf8m09WRwpE6k9Fp8YFoSR0AxFLQMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexf0dhrczcusZGYCDP6lsK2qeXKCrXyj_90N9BUIhnld4Meta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexT5QRaxL__45oX1bL0EueHsA94qAt_45gVcdFI470tmlARS0Meta } from "/codebuild/output/src2789643278/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index1DwBl8kXM5lz_E8R9d0o0xdt9oIF6uCY5wSl1mUGfOcMeta } from "/codebuild/output/src2789643278/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatefXQz8znyDouy64m9yTur6xnzrExjM5AzzjE_Kmh_RMQMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmqNykWoyjcJFk1EwdcPDJYml6BhAiT49HKbutDjUXXdYMeta } from "/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu4UrgUIe73GdKEqFBj1MpQrWOU0uTGamP425SZdGsOIkMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexhQTgSTZRzVbMrMXGm1wiodeFu4nZwwyKfhNDSRVVFSkMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src2789643278/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexdCQVJ3eZDOBttHYmITFcGegOKFvXy0Q6s0Hr34v4KZgMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2789643278/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexY6W_45CjrZRH29Gkl_knQg_60eCTd1aKlJR0U_SQS3DUgMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2789643278/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexhyoIhcgTdbqSKcp4b5RTNVP4DTS_8kXVy5vrEosnOIcMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexW1wkTDIMQDCaQYWu9V3h4ZRuQJDIvP5kHdFhRo1GXQQMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index59CaNQmQI2baCC1J4vI1TGbxMYpinL3hxxEv_P1vlg0Meta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm2UXYH7VpR4ImEusLwU3DSKsq9OGvoUpDEvxbVjXCM5gMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmeKDNzv1V_IyB4qi0QzxnBYEK2qVzScsKgpKoU2ZQ1mUMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2789643278/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete1RroXVrLXcJKDXj_0yivpwqzU3Bij388cxjRE9RDoloMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerzi9GOQWoaNIoK1fv_qTXKLTShyyt9k6gXi7MP18Xt0MMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmf6T8JHGxLgSvm5_45uqt4Fta8WTTsH70pmunV2hHJlTj0Meta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code7Bv7MetmFgGRBxn11UB4p3tam7p4GfthBcDU7GfzBX0Meta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codehPOUwPIhEogHj6_45Q6cafp_HDpcc_x_2KFdoXRTNd6MEMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completebTGmSzQNfjviUsYws9f92Nc9timfjMSsLTzgr6YxQbsMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registeruayssARFl6Mkd_45ebARHmddpnkjnIwAhp9Yg_2jRFKgYMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmmcCQdSJAe_45lKUPMm220t4t95alcQR4kVk_45ublRlQhGsMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completez0RDEO6A8fSprmYlcfe67M3VNoS3Jt3DfoSZW0X21GIMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexCySB7Hm2GZqvivSpI0WvxP7lbXT9AgbpNdwcpQ7amwAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completetrU5ir6TUorYApa47HqwHQhdJD1Jtg2bGlzLWOdJDZYMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleMuvlzRGukcCr_45sOE8IkcCDUb6HazXZOQzbOIzk6QFecMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email5HKgph4Zq3k_45hdxZzU2NBh_45g6zy0XHj8eXXyxkNXDQQMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmhGa_45ebCaN5IW3ooLVTiNxcvUocQnaoNxFebmvjA_45_45GAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentXzxfpZyLKybOYvXexUeQoUbk6G3eVrzSqBv3fwkE7AsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmODwDnRGpIEjjOOHClkTi_45vCAF_T5TOFmnqiOdIS8d2QMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeafVJ7fdM34dV2PvuWtTcxPxKvWYHu1J5yaieDPN1ilAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeSfEKBA5l_45Z7XWYF9yMLbtIPOCaKyBGk6yDP_jyUUL68Meta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordwf2PwgtYOFZE_hqGEhwV_452WYJ1lq8iGGGhpuLPnAIQIMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerV9XEYnAIsGc6FsWkaoaYeKvEzVfHr0jgTq_4bZ_3i4MMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeSaDYftndsEgsRWvWnDBkj_2WL0MJ1QQYNaiXi6hi2mYMeta || {},
    component: () => import("/codebuild/output/src2789643278/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2789643278/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]